"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecomFetch = void 0;
const normalizers_adabyron_abs_layer_get_credit_1 = __importDefault(require("@gcloud-npm/normalizers.adabyron.abs-layer.get-credit"));
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const getRecomFetch = (userIdPartyHash) => __awaiter(void 0, void 0, void 0, function* () {
    let recomResponse = null;
    let userIdPartyHash2Use = userIdPartyHash;
    const module = yield Promise.resolve().then(() => __importStar(require("@gcloud-npm/adabyron.abs-layer.get-credit")));
    const getCredit = module.default;
    try {
        if (localStorage.getItem('AUTH_DEBUG_ID_PARTY_HASH')) {
            userIdPartyHash2Use = localStorage.getItem('AUTH_DEBUG_ID_PARTY_HASH');
            console.warn('has mockeado', userIdPartyHash2Use);
        }
        recomResponse = yield getCredit({ userIdPartyHash: userIdPartyHash2Use });
    }
    catch (e) {
        console.error(e);
    }
    finally {
        return recomResponse;
    }
});
exports.getRecomFetch = getRecomFetch;
const shouldRequestRecom = (persistedInfo) => {
    const tsUserRecom = persistedInfo.tsUserRecom ? persistedInfo.tsUserRecom : null;
    let res = true;
    // mas de las 24
    if (tsUserRecom) {
        const tsNow = Date.now();
        const msDay = 1000 * 60 * 60 * 24;
        const diferenciaEnMilisegundos = tsUserRecom !== -1 ? tsNow - tsUserRecom : msDay;
        const diferenciaEnHoras = diferenciaEnMilisegundos / (1000 * 60 * 60);
        res = diferenciaEnHoras >= 24;
    }
    return res;
};
const getRecom = ({ persistedInfo, ad_storage, analytics_storage, setUserRecom, setUserPqInfo }) => __awaiter(void 0, void 0, void 0, function* () {
    // 1) Solo si ha aceptado las cookies guardamos las recomendaciones del usuario
    //          Sino, lo guardamos como nulo ya que, o no ha aceptado cookies o no esta logado
    let userRecom = null;
    let secureStorage = new utils_secure_local_storage_1.default();
    const isCookieGranted = ad_storage === "granted" && analytics_storage === "granted";
    if (isCookieGranted && persistedInfo.userIdPartyHash) {
        userRecom = (persistedInfo && persistedInfo.userRecom) || null;
        const shouldRequestRecomCdn = shouldRequestRecom(persistedInfo);
        //  ponemos la limitaciond e las 24 y sino le creamos la marca
        if (shouldRequestRecomCdn && persistedInfo.userIdPartyHash) {
            let recomResponse = null;
            try {
                recomResponse = yield (0, exports.getRecomFetch)(persistedInfo.userIdPartyHash);
                const { userRecom, userPq } = (0, normalizers_adabyron_abs_layer_get_credit_1.default)({
                    response: recomResponse,
                    userPq: persistedInfo.userPq || {}
                });
                // hay nueva recomendación
                if (userRecom) {
                    setUserRecom({ userRecom });
                    // Limite de credito
                    setUserPqInfo({ userPq });
                    const persistedInfo = secureStorage.getItem("ts");
                    secureStorage.setItem("ts", Object.assign(Object.assign({}, persistedInfo), { userRecom,
                        userPq, tsUserRecom: Date.now() }));
                }
                // responde el api y no hay recom
                if (!userRecom) {
                    const persistedInfo = secureStorage.getItem("ts");
                    secureStorage.setItem("ts", Object.assign(Object.assign({}, persistedInfo), { tsUserRecom: Date.now() }));
                }
            }
            catch (e) {
                console.log(e);
            }
        }
    }
});
exports.default = getRecom;
//# sourceMappingURL=index.js.map